import Stack from '@careguide/stack'
import React from 'react'
import Button from 'components/generic/Button'
import DropdownLink from '../DropdownLink'
import TopCitiesDropdown from './TopCitiesDropdown'
import styled from 'styled-components'
import { css } from '@styled-system/css'
import { HeaderLink } from '../HeaderLink'

export type NavigationDesktopProps = {
  getStartedCta: {
    link: string
    text: string
  }
  links: any[]
  topCitiesLinks: any[]
}

export const NavDesktopLoggedOut = ({
  getStartedCta,
  links,
  topCitiesLinks,
}: NavigationDesktopProps) => (
  <>
    <Stack gap='5' direction='horizontal' valign='center'>
      {links.map((item, index) => (
        <DropdownLink key={index} primaryLink={item} />
      ))}
    </Stack>
    <Stack gap='4' align='right' valign='center' direction='horizontal'>
      <TopCitiesDropdown items={topCitiesLinks} />
      <LoginLink href='/log-in'>Log in</LoginLink>
      <Button href={getStartedCta.link} rel='nofollow'>
        {getStartedCta.text}
      </Button>
    </Stack>
  </>
)

const LoginLink = styled(HeaderLink)`
  ${css({
    minWidth: 'fit-content',
    display: 'inline-block',
    boxSizing: 'border-box',
  })}
`
